export const addSensorInputs = [
  {
    name: "BLE Tags Name",
    key: "sensorName",
    value: "xxxxx",
  },
  {
    name: "Manufacturer",
    key: "manufacturer",
    value: "xxxxx",
  },
  {
    name: "Signal strength",
    key: "signalStrength",
    value: "100%",
  },
  {
    name: "BLE Tags Health Score",
    key: "sensorHealthScore",
    value: "xxxxx",
  },
  {
    name: "BLE Tags Location",
    key: "sensorLocation",
    value: "xxxxx",
  },
  {
    name: "BLE Tags Model",
    key: "sensorModel",
    value: "xxxxx",
  },
  {
    name: "BLE Tags Id",
    key: "sensorId",
    value: "xxxxx",
  },
  {
    name: "Battery Level",
    key: "batteryLevel",
    value: "100%",
  },
];


export const stateVal ={
  "data": [
      {
          "qrcode": "866392062764539",
          "imei": 866392062764539,
          "refidtype": "imei",
          "refid": "866392062764539",
          "sku": "VZW160003260010",
          "providerid": "9dfcfa69-a1c8-4eae-8611-b282646bb113",
          "state": "ready",
          "services": [
              "configuration"
          ],
          "eventretention": 90,
          "billingaccountid": "0842080288-00001",
          "foreignid": "e1919a4b-2760-61be-f888-8cb151812fa8",
          "accountclientid": "DakotaClientAppV2",
          "id": 866392062764539,
          "kind": "ts.device.tgAssetTracker",
          "version": "1.0",
          "versionid": "5faff37e-0bf3-479c-a76c-ac580ed0627e",
          "createdon": "Mar 06 2024 16:46:15",
          "lastupdated": "Mar 06 2024 16:49:33",
          "name": "cat866392062764539",
          "fields": {
              "ilm": {
                  "more": 1,
                  "scanDuration": 2,
                  "scans": [
                      {
                          "rssi": [
                              0,
                              -82,
                              -69,
                              -81,
                              -82,
                              -84,
                              0
                          ],
                          "sid": "71728C0122"
                      },
                      {
                          "rssi": [
                              0,
                              -74,
                              0,
                              -78,
                              -73,
                              -75,
                              0
                          ],
                          "sid": "71728C0124"
                      },
                      {
                          "rssi": [
                              -78,
                              -88,
                              -88,
                              -77,
                              0,
                              0,
                              0
                          ],
                          "sid": "1260E7B922"
                      },
                      {
                          "rssi": [
                              0,
                              -80,
                              -82,
                              -82,
                              -81,
                              -81,
                              0
                          ],
                          "sid": "71728C01D2"
                      },
                      {
                          "rssi": [
                              0,
                              -88,
                              -82,
                              -87,
                              -88,
                              -87,
                              0
                          ],
                          "sid": "71728C0123"
                      }
                  ]
              },
              "location": {
                  "accuracy": 74,
                  "latitude": 39.55276817,
                  "longitude": -104.87565463,
                  "type": "wifi"
              },
              "orientation": {
                  "motionInX": 3,
                  "motionInY": 2,
                  "motionInZ": 0,
                  "tiltZ": 3
              },
              "pressure": 788,
              "temperature": 20.5,
              "acceleration": {
                  "rms": 1.0579,
                  "x": 0.0334,
                  "y": 0.0513,
                  "z": 1.0562
              },
              "humidity": 14,
              "light": 432,
              "signalStrength": -82,
              "battery": 100,
              "deviceConfig": {
                  "accelerometer": {
                      "monitorPeriod": 900,
                      "opMode": 0,
                      "reportOffset": 0,
                      "reportPeriod": 900,
                      "reportType": 2
                  },
                  "battery": {
                      "monitorPeriod": 900,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 900,
                      "reportType": 2
                  },
                  "ble": {
                      "dataMode": 1,
                      "manufacturerId": 65097,
                      "maxNumScan": 100,
                      "minSigStr": -120,
                      "monitorPeriod": 900,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 900,
                      "reportType": 2,
                      "scanDuration": 2
                  },
                  "device": {
                      "commMaxAwakeDuration": 80,
                      "commMinAwakeDuration": 40,
                      "commPeriodSet": 900,
                      "commSynchPeriod": 900,
                      "commType": "forced",
                      "commTypeUpdate": "forced"
                  },
                  "gyro": {
                      "monitorPeriod": 900,
                      "opMode": 0,
                      "reportOffset": 0,
                      "reportPeriod": 900,
                      "reportType": 2
                  },
                  "humidity": {
                      "monitorPeriod": 900,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 900,
                      "reportType": 2
                  },
                  "light": {
                      "monitorPeriod": 900,
                      "opMode": 0,
                      "reportOffset": 0,
                      "reportPeriod": 900,
                      "reportType": 2
                  },
                  "location": {
                      "monitorPeriod": 900,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 900,
                      "reportType": 2
                  },
                  "pressure": {
                      "monitorPeriod": 900,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 900,
                      "reportType": 2
                  },
                  "rfSignal": {
                      "monitorPeriod": 900,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 900,
                      "reportType": 2
                  },
                  "temperature": {
                      "monitorPeriod": 900,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 900,
                      "reportType": 2
                  },
                  "wifi": {
                      "minSigStr": -180,
                      "monitorPeriod": 900,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 900,
                      "reportType": 2,
                      "scanDuration": 10
                  }
              }
          },
          "modelmetadata": null,
          "commands": {},
          "uid": "a4a13469-6fd7-6336-ec40-9ffc944f7ba6",
          "nickname": "BLE Gateway",
          "isSensor": false
      },
      {
          "qrcode": "866392062737493",
          "imei": 866392062737493,
          "refidtype": "imei",
          "refid": "866392062737493",
          "providerid": "9dfcfa69-a1c8-4eae-8611-b282646bb113",
          "state": "ready",
          "services": [
              "configuration"
          ],
          "eventretention": 90,
          "billingaccountid": "0842080288-00001",
          "foreignid": "e1919a4b-2760-61be-f888-8cb151812fa8",
          "accountclientid": "DakotaClientAppV2",
          "id": 866392062737493,
          "kind": "ts.device.tgAssetTracker",
          "version": "1.0",
          "versionid": "3cccfeb4-e5fc-4c49-a1e0-607be1d467cb",
          "createdon": "Mar 05 2024 17:05:10",
          "lastupdated": "Mar 05 2024 17:35:16",
          "name": "cat866392062737493",
          "fields": {
              "deviceConfig": {
                  "accelerometer": {
                      "monitorPeriod": 900,
                      "opMode": 0,
                      "reportOffset": 0,
                      "reportPeriod": 900,
                      "reportType": 2
                  },
                  "battery": {
                      "monitorPeriod": 900,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 900,
                      "reportType": 2
                  },
                  "ble": {
                      "dataMode": 1,
                      "manufacturerId": 65097,
                      "maxNumScan": 100,
                      "minSigStr": -120,
                      "monitorPeriod": 900,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 900,
                      "reportType": 2,
                      "scanDuration": 2
                  },
                  "device": {
                      "commMaxAwakeDuration": 80,
                      "commMinAwakeDuration": 40,
                      "commPeriodSet": 900,
                      "commSynchPeriod": 900,
                      "commType": "forced",
                      "commTypeUpdate": "forced"
                  },
                  "gyro": {
                      "monitorPeriod": 900,
                      "opMode": 0,
                      "reportOffset": 0,
                      "reportPeriod": 900,
                      "reportType": 2
                  },
                  "humidity": {
                      "monitorPeriod": 900,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 900,
                      "reportType": 2
                  },
                  "light": {
                      "monitorPeriod": 900,
                      "opMode": 0,
                      "reportOffset": 0,
                      "reportPeriod": 900,
                      "reportType": 2
                  },
                  "location": {
                      "monitorPeriod": 900,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 900,
                      "reportType": 2
                  },
                  "pressure": {
                      "monitorPeriod": 900,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 900,
                      "reportType": 2
                  },
                  "rfSignal": {
                      "monitorPeriod": 900,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 900,
                      "reportType": 2
                  },
                  "temperature": {
                      "monitorPeriod": 900,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 900,
                      "reportType": 2
                  },
                  "wifi": {
                      "minSigStr": -180,
                      "monitorPeriod": 900,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 900,
                      "reportType": 2,
                      "scanDuration": 10
                  }
              },
              "humidity": 17,
              "ilm": {
                  "more": 0,
                  "scanDuration": 2,
                  "scans": [
                      {
                          "rssi": [
                              -85,
                              -86,
                              -84,
                              -86,
                              0,
                              0,
                              0
                          ],
                          "sid": "71728C0120"
                      },
                      {
                          "rssi": [
                              -62,
                              -62,
                              -67,
                              -62,
                              -62,
                              0,
                              0
                          ],
                          "sid": "1260E7B9BA"
                      },
                      {
                          "rssi": [
                              -77,
                              0,
                              -86,
                              -84,
                              -75,
                              -77,
                              0
                          ],
                          "sid": "71728C01D6"
                      }
                  ]
              },
              "pressure": 796,
              "signalStrength": -83,
              "temperature": 19.3,
              "acceleration": {
                  "rms": 1.0638,
                  "x": 0.0106,
                  "y": 0.0473,
                  "z": 1.0626
              },
              "battery": 100,
              "orientation": {
                  "motionInX": 3,
                  "motionInY": 1,
                  "motionInZ": 0,
                  "tiltZ": 3
              },
              "light": 1121,
              "location": {
                  "accuracy": 127,
                  "latitude": 39.55288971,
                  "longitude": -104.87588159,
                  "type": "wifi"
              }
          },
          "modelmetadata": null,
          "commands": {},
          "uid": "c4b1d26b-41a6-6d95-f894-d41b52defc6e",
          "nickname": "BLE Gateway",
          "isSensor": false
      },
      {
          "qrcode": "865284049952256",
          "imei": 865284049952256,
          "refidtype": "imei",
          "refid": "865284049952256",
          "providerid": "9dfcfa69-a1c8-4eae-8611-b282646bb113",
          "state": "ready",
          "services": [
              "configuration"
          ],
          "eventretention": 90,
          "billingaccountid": "0842080288-00001",
          "foreignid": "e1919a4b-2760-61be-f888-8cb151812fa8",
          "accountclientid": "DakotaClientAppV2",
          "id": 865284049952256,
          "kind": "ts.device.tgAssetTracker",
          "version": "1.0",
          "versionid": "1607c468-86d8-4c76-a38a-5b2981038811",
          "createdon": "Mar 04 2024 21:18:47",
          "lastupdated": "Mar 04 2024 22:17:10",
          "name": "cat865284049952256",
          "fields": {
              "light": 14,
              "location": {
                  "accuracy": 7,
                  "latitude": 34.120864,
                  "longitude": -84.233792,
                  "type": "gps"
              },
              "signalStrength": -81,
              "acceleration": {
                  "rms": 1.0106,
                  "x": -1.0072,
                  "y": 0.0586,
                  "z": 0.0586
              },
              "ble": {
                  "dataMode": 1,
                  "manufacturerId": 2533,
                  "numReport": 1,
                  "sensorList": []
              },
              "deviceConfig": {
                  "accelerometer": {
                      "monitorPeriod": 300,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 300,
                      "reportType": 2
                  },
                  "battery": {
                      "monitorPeriod": 300,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 300,
                      "reportType": 2
                  },
                  "ble": {
                      "dataMode": 1,
                      "manufacturerId": 2533,
                      "maxNumScan": 100,
                      "minSigStr": -115,
                      "monitorPeriod": 300,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 300,
                      "reportType": 2,
                      "scanDuration": 5
                  },
                  "device": {
                      "commMaxAwakeDuration": 80,
                      "commMinAwakeDuration": 40,
                      "commPeriodSet": 300,
                      "commSynchPeriod": 300,
                      "commType": "forced",
                      "commTypeUpdate": "forced"
                  },
                  "gyro": {
                      "monitorPeriod": 300,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 300,
                      "reportType": 2
                  },
                  "humidity": {
                      "monitorPeriod": 300,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 300,
                      "reportType": 2
                  },
                  "light": {
                      "monitorPeriod": 300,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 300,
                      "reportType": 2
                  },
                  "location": {
                      "monitorPeriod": 300,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 300,
                      "reportType": 2
                  },
                  "pressure": {
                      "monitorPeriod": 300,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 300,
                      "reportType": 2
                  },
                  "rfSignal": {
                      "monitorPeriod": 300,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 300,
                      "reportType": 2
                  },
                  "temperature": {
                      "monitorPeriod": 300,
                      "opMode": 1,
                      "reportOffset": 0,
                      "reportPeriod": 300,
                      "reportType": 2
                  },
                  "wifi": {
                      "minSigStr": -180,
                      "monitorPeriod": 300,
                      "opMode": 0,
                      "reportOffset": 0,
                      "reportPeriod": 300,
                      "reportType": 2,
                      "scanDuration": 10
                  }
              },
              "humidity": 44,
              "battery": 100,
              "orientation": {
                  "motionInX": 3,
                  "motionInY": 85,
                  "motionInZ": 0,
                  "tiltZ": 87
              },
              "pressure": 948,
              "temperature": 18.2
          },
          "modelmetadata": null,
          "commands": {},
          "uid": "c47106e5-5533-6da9-f08e-babc925f6101",
          "nickname": "BLE Gateway",
          "isSensor": false
      },
      {
          "qrcode": "865284049952173",
          "imei": 865284049952173,
          "refidtype": "imei",
          "refid": "865284049952173",
          "providerid": "9dfcfa69-a1c8-4eae-8611-b282646bb113",
          "state": "ready",
          "services": [
              "configuration"
          ],
          "eventretention": 90,
          "billingaccountid": "0842080288-00001",
          "foreignid": "e1919a4b-2760-61be-f888-8cb151812fa8",
          "accountclientid": "DakotaClientAppV2",
          "id": 865284049952173,
          "kind": "ts.device.tgAssetTracker",
          "version": "1.0",
          "versionid": "d0ef698d-5846-4cf2-8810-646ee0182960",
          "createdon": "Feb 21 2024 20:42:07",
          "lastupdated": "Feb 21 2024 21:48:33",
          "name": "cat865284049952173",
          "fields": {
              "acceleration": {
                  "rms": 1.0111,
                  "x": -0.7022,
                  "y": 0.0438,
                  "z": 0.726
              },
              "battery": 100,
              "deviceAlarm": {
                  "humidity": {
                      "Threshold": 45,
                      "alarmType": 3,
                      "sensorReading": 39,
                      "state": 1
                  },
                  "light": {
                      "Threshold": 65,
                      "alarmType": 2,
                      "sensorReading": 112,
                      "state": 1
                  },
                  "shock": {
                      "alarmType": 12,
                      "holdoff": 60,
                      "location": {
                          "accuracy": 8,
                          "latitude": 33.103809,
                          "longitude": -96.764392,
                          "type": "gps"
                      },
                      "locationRequired": 0,
                      "magnitude": 2.2747,
                      "setOnlyOnce": 0,
                      "shock_duration": 0.1,
                      "shock_thresh": 1,
                      "state": 1,
                      "x": -0.0258,
                      "x_axis": 0,
                      "y": -0.2438,
                      "y_axis": 0,
                      "z": 2.2615,
                      "z_axis": 1
                  }
              },
              "humidity": 38,
              "location": {
                  "accuracy": 9,
                  "latitude": 34.120864,
                  "longitude": -84.233871,
                  "type": "gps"
              },
              "pressure": 943,
              "deviceConfig": {
                  "accelerometer": {
                      "monitorPeriod": 300,
                      "opMode": 1,
                      "range": 0,
                      "reportOffset": "1970-01-01T00:00:00Z",
                      "reportPeriod": 900,
                      "reportType": 2,
                      "scalefactor": 8,
                      "sensitivity": 5
                  },
                  "acclAlarm": [
                      {
                          "accel_thresh": 0.20000000298023224,
                          "alarmType": 5,
                          "enabled": 0,
                          "holdoff": 30,
                          "locationRequired": 0,
                          "p1": 0,
                          "p2": 0,
                          "p3": 0,
                          "p4": 0,
                          "p5": 0,
                          "setOnlyOnce": 0,
                          "stopped_period": 300,
                          "stopped_thresh": 0.07999999821186066
                      },
                      {
                          "alarmType": 8,
                          "enabled": 0,
                          "holdoff": 30,
                          "locationRequired": 0,
                          "p1": 0,
                          "p2": 0,
                          "p3": 0,
                          "p4": 0,
                          "p5": 0,
                          "setOnlyOnce": 0,
                          "tap_duration": 0.10000000149011612,
                          "tap_thresh": 1.5
                      },
                      {
                          "alarmType": 12,
                          "enabled": 0,
                          "holdoff": 30,
                          "locationRequired": 0,
                          "p1": 0,
                          "p2": 0,
                          "p3": 0,
                          "p4": 0,
                          "p5": 0,
                          "setOnlyOnce": 0,
                          "shock_duration": 0.10000000149011612,
                          "shock_thresh": 1.5,
                          "x_axis": 1,
                          "y_axis": 1,
                          "z_axis": 1
                      }
                  ],
                  "battAlarm": {
                      "alarmType": 0,
                      "holdoff": 1800,
                      "hysteresis": 3,
                      "threshold": 0,
                      "thresholdRange": 0
                  },
                  "battery": {
                      "monitorPeriod": 20,
                      "opMode": 1,
                      "reportOffset": "2024-02-22T14:38:17Z",
                      "reportPeriod": 20,
                      "reportType": 2
                  },
                  "ble": {
                      "dataMode": 0,
                      "manufacturerId": 0,
                      "maxNumScan": 0,
                      "minSigStr": 0,
                      "monitorPeriod": 300,
                      "opMode": 0,
                      "reportOffset": "1970-01-01T00:00:00Z",
                      "reportPeriod": 900,
                      "reportType": 2,
                      "scanDuration": 0
                  },
                  "cfgRefTime": 0,
                  "device": {
                      "commMaxAwakeDuration": 80,
                      "commMinAwakeDuration": 40,
                      "commPeriodSet": 900,
                      "commSynchPeriod": 900,
                      "commType": "forced",
                      "commTypeUpdate": "forced"
                  },
                  "gyro": {
                      "monitorPeriod": 300,
                      "opMode": 1,
                      "reportOffset": "1970-01-01T00:00:00Z",
                      "reportPeriod": 900,
                      "reportType": 2
                  },
                  "gyroAlarm": {
                      "alarmType": 0,
                      "clear_duration": 0,
                      "enabled": 0,
                      "holdoff": 0,
                      "locationRequired": 0,
                      "setOnlyOnce": 0,
                      "tilt_angle": 0,
                      "tilt_duration": 0,
                      "x_axis": 0,
                      "y_axis": 0,
                      "z_axis": 0
                  },
                  "humiAlarm": {
                      "alarmType": 3,
                      "holdoff": 1800,
                      "threshold": 45,
                      "thresholdRange": 10
                  },
                  "humidity": {
                      "monitorPeriod": 20,
                      "opMode": 1,
                      "reportOffset": "2024-02-22T14:38:17Z",
                      "reportPeriod": 20,
                      "reportType": 2
                  },
                  "light": {
                      "monitorPeriod": 60,
                      "opMode": 1,
                      "reportOffset": "2024-02-22T14:38:17Z",
                      "reportPeriod": 60,
                      "reportType": 2
                  },
                  "liteAlarm": {
                      "alarmType": 2,
                      "holdoff": 1800,
                      "threshold": 65,
                      "thresholdRange": 10
                  },
                  "locAlarm": {
                      "alarmType": 0,
                      "holdoff": 1800,
                      "motion": 0
                  },
                  "location": {
                      "monitorPeriod": 20,
                      "opMode": 1,
                      "reportOffset": "2024-02-22T14:38:17Z",
                      "reportPeriod": 20,
                      "reportType": 2
                  },
                  "presAlarm": {
                      "alarmType": 0,
                      "holdoff": 1800,
                      "threshold": 0,
                      "thresholdRange": 0
                  },
                  "pressure": {
                      "monitorPeriod": 40,
                      "opMode": 1,
                      "reportOffset": "2024-02-22T14:38:17Z",
                      "reportPeriod": 40,
                      "reportType": 2
                  },
                  "profileAlarm": [],
                  "profileId": 0,
                  "rfSignal": {
                      "monitorPeriod": 20,
                      "opMode": 1,
                      "reportOffset": "2024-02-22T14:38:17Z",
                      "reportPeriod": 20,
                      "reportType": 2
                  },
                  "rssiAlarm": {
                      "alarmType": 0,
                      "holdoff": 0,
                      "threshold": 0,
                      "thresholdRange": 0
                  },
                  "tempAlarm": {
                      "alarmType": 2,
                      "holdoff": 1800,
                      "hysteresis": 1,
                      "threshold": 70,
                      "thresholdRange": 10
                  },
                  "temperature": {
                      "monitorPeriod": 30,
                      "opMode": 1,
                      "reportOffset": "2024-02-22T14:38:17Z",
                      "reportPeriod": 30,
                      "reportType": 2
                  },
                  "wifi": {
                      "minSigStr": -150,
                      "monitorPeriod": 900,
                      "opMode": 0,
                      "reportOffset": "1970-01-01T00:00:00Z",
                      "reportPeriod": 900,
                      "reportType": 2,
                      "scanDuration": 10
                  }
              },
              "deviceDiagnostic": {
                  "firmwareVersion": "2.12.2",
                  "fotaFirmwareVersion": "0.15.0",
                  "radioFirmwareVersion": "BG96MAR04A05M1G",
                  "tsSdkFirmwareVersion": "TSSDK_V2.1.11.0-GAT"
              },
              "light": 12,
              "orientation": {
                  "motionInX": 2,
                  "motionInY": 44,
                  "motionInZ": 0,
                  "tiltZ": 44
              },
              "signalStrength": -84,
              "temperature": 20.7
          },
          "modelmetadata": null,
          "commands": {},
          "uid": "2471a30e-0c6f-6f3d-e19f-754f99865163",
          "nickname": "BLE Gateway",
          "isSensor": false
      }
  ]
}